import { render, staticRenderFns } from "./HomeLetter.vue?vue&type=template&id=2d510b18&"
import script from "./HomeLetter.vue?vue&type=script&lang=js&"
export * from "./HomeLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports